import * as React from 'react';
import { FormControl } from '@mui/material';
import { FieldArray } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { legalTitleHolderInitialValue } from '../../../util/initial-values';
import { NAME_SUFFIX_OPTIONS } from '../../../models/options/options';
import { requiredArray } from '../../../util/validators';

const legalTitleHolderInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.legalTitleHolderFirstName,
    isOptional : false,
    label      : 'First Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.legalTitleHolderMiddleName,
    isOptional : true,
    label      : 'Middle Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.legalTitleHolderLastName,
    isOptional : false,
    label      : 'Last Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.legalTitleHolderSuffixName,
    isOptional : true,
    label      : 'Suffix',
    options    : NAME_SUFFIX_OPTIONS,
    type       : DynamicFormFieldArrayType.SELECT,
  },
];

const legalTitleHolderProps: DynamicFormFieldArray = {
  addButtonText : 'Title Holder',
  initialValue  : legalTitleHolderInitialValue,
  inputs        : legalTitleHolderInputs,
};

export const LegalTitleHoldersComponent = ({ ...props }) => {
  const { name } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = {name}
        props     = {{ dynamicProps: legalTitleHolderProps, name, t }}
        validate  = {[requiredArray([FieldNames.legalTitleHolderFirstName, FieldNames.legalTitleHolderLastName])]}
      />
    </FormControl>
  );
};
